import styled, { css } from 'styled-components';

export const NotificationWrapper = styled.div(
  ({ theme }) => css`
    position: fixed;
    bottom: ${theme.sz.s20};
    right: ${theme.sz.s6};
    z-index: ${theme.zi.modal};
    width: ${theme.sz.s};
    max-width: max-content;

    @media (max-width: ${theme.sz.md}) {
      left: 50%;
      padding: 0 ${theme.sz.s4};
      width: ${theme.sz.xs};
      transform: translate(-50%);
    }

    @media (min-width: ${theme.sz.xxxxl}) {
      left: 97rem;
    }
  `,
);
